import { StorageService } from './storage.service';
import * as localForage from 'localforage';
import {Inject, Injectable} from '@angular/core';
@Injectable()
export class BrowserStorage implements StorageService {
  data: any;
  constructor() {
    this.data = localForage.createInstance({name: 'interstitial'})
  }

  getItem<T>(key: string): Promise<T | null> {
    return this.data.getItem(key);
  }
  setItem<T>(key: string, value: T): Promise<T> {
    return this.data.setItem(key, value);
  }
  removeItem(key: string, callback?: (err: any) => void): Promise<void> {
    return this.data.removeItem(key, callback);
  }
  clear() {
    return this.data.clear();
  }
}
